import { post } from "./base";

const ImportExportServ = {
    importEntity: (entity, payload) => post(`/import-export/import/${entity}`, payload),
};

export default ImportExportServ;
